/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track the trend over weeks rather than a single reading.`)
};

const es_bf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigue la tendencia a lo largo de las semanas en vez de una sola lectura.`)
};

const de_bf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolge den Trend über mehrere Wochen statt einer einzelnen Messung.`)
};

const nl_bf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volg de trend over meerdere weken in plaats van één enkele meting.`)
};

const fr_bf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivez la tendance sur plusieurs semaines plutôt qu'une seule mesure.`)
};

const it_bf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segui l'andamento nel tempo piuttosto che una singola lettura.`)
};

const pt_br2_bf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhe a tendência ao longo de semanas, não uma única medição.`)
};

const pt_bf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhe a tendência ao longo de semanas, e não uma única leitura.`)
};

const ja_bf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1回の測定値ではなく、数週間の傾向を追いましょう。`)
};

const zh_bf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建议跟踪数周内的变化趋势，而非单次读数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_ex3", locale)
	if (locale === "en") return en_bf_ex3(inputs)
	if (locale === "es") return es_bf_ex3(inputs)
	if (locale === "de") return de_bf_ex3(inputs)
	if (locale === "nl") return nl_bf_ex3(inputs)
	if (locale === "fr") return fr_bf_ex3(inputs)
	if (locale === "it") return it_bf_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_bf_ex3(inputs)
	if (locale === "pt") return pt_bf_ex3(inputs)
	if (locale === "ja") return ja_bf_ex3(inputs)
	return zh_bf_ex3(inputs)
};